export function Timeout(timeout = 0): (target: Object, propertyKey: string, descriptor: TypedPropertyDescriptor<any>) => TypedPropertyDescriptor<any> {
  return (target: Object, propertyKey: string, descriptor: TypedPropertyDescriptor<any>): TypedPropertyDescriptor<any> => {
    const originalMethod = descriptor.value;

    descriptor.value = function(...args: any[]): void {
      setTimeout(originalMethod.bind(this, ...args), timeout);
    };

    return descriptor;
  };
}
